








import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Version extends Vue {

    private get meta() {
        return this.$store.getters['meta/getMeta']();
    }

    private get env() {
        return this.meta.env;
    }

    private get isDev() {
        return 'dev' === this.env;
    }

    private get isTraining() {
        return 'trn' === this.env;
    }

    private get isProd() {
        return 'prod' === this.env;
    }

    private get version() {
        return this.meta.version;
    }

    private get styling() {
        return {
            'env-dev': this.isDev,
            'env-training': this.isTraining
        };
    }

    private mounted() {
        this.$store.dispatch('meta/loadMeta');
    }
}
